export default "__VITE_ASSET__y5$MW9iD__"